
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/joiner-mover-leaver",
      function () {
        return require("private-next-pages/solutions/joiner-mover-leaver.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/joiner-mover-leaver"])
      });
    }
  